<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-col cols="12 text-center">
            <h2>{{ $t('perfil_sga.titulo_datos') }}</h2>
            <p class="subtitle">{{ $t('perfil_sga.subtitulo_datos') }}</p>
        </b-col>
        <b-col cols="12">
            <b-row class="p-0 mt-5 p-md-5">
                <b-col cols="12" md="6">
                    <FormInput
                        :label="$t('formularios.nombre')"
                        name="nombre"
                        rules="required"
                        v-model="data.name"
                    />
                </b-col>
                <b-col cols="12" md="6">
                    <FormInput
                        :label="$t('formularios.apellidos')"
                        name="apellidos"
                        rules="required"
                        v-model="data.surnames"
                    />
                </b-col>
                <b-col cols="12" md="6">
                    <FormInput
                        label="DNI"
                        name="dni"
                        rules="required"
                        v-model="data.nif"
                    />
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="data.genero"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                id="genero"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="opt => { data.genero_id = opt.id; }"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <FormInput
                        :label="$t('formularios.email')"
                        name="email"
                        rules="required|email"
                        :apiValidationError="errors?.email"
                        v-model="data.email"
                    />
                </b-col>
                <b-col cols="12" md="6">
                    <div class="form-group">
                        <label for="telefono">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            name="telefono"
                            :phone="data.telefono"
                            :required="true"
                            :error_telefono="data.error_telefono"
                            @setNumber="(number) => data.telefono = number"
                            @validNumber="(valid) => data.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            :desactivar="false"
                            :pais="data.pais"
                            @selected="opt => {
                                data.pais_id = opt.id;
                                data.pais = opt;
                                data.provincia = null;
                                data.provincia_id = null;
                                data.localidad = null;
                                data.localidad_id = null;
                            }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            :key="data.pais_id"
                            :desactivar="false"
                            :pais="data.pais.id"
                            :provincia="data.provincia"
                            @selected="opt => {
                                data.provincia = opt;
                                data.provincia_id = opt.id;
                            }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :forceMultiselect="true"
                            :key="data.provincia_id"
                            :desactivar="data.provincia_id === null"
                            :provincia="data.provincia"
                            :localidad="data.localidad"
                            @selected="opt => { data.localidad = opt; data.localidad_id = opt.id; }"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" class="text-center mb-3">
            <b-button
                type="submit"
                class="col-12 col-md-4"
                :disabled="loading || !isChanged || !data.isValidNumber"
            >
                guardar
            </b-button>
        </b-col>
    </ValidationObserver>
</template>

<script>
    import Paises from '@/components/common/forms/Paises';
    import Provincias from '@/components/common/forms/Provincias';
    import Locations from '@/components/common/forms/Locations';
    import PhoneInput from '@/components/common/PhoneInput';
    import Generos from "@/mixins/Generos";

    export default {
        mixins: [Generos],
        name: 'DatosCleComponent',
        props: {
            usuario: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                data: { ...this.usuario, isValidNumber: false },
                originalData: { ...this.usuario },
                errors: {},
                loading: false,
            };
        },
        mounted() {
            this.getGeneros();
        },
        computed: {
            isChanged() {
                return JSON.stringify(this.data) !== JSON.stringify(this.originalData);
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.updatePerfil();
                }
            },
            updatePerfil() {
                this.loading = true;

                const { pais, provincia, localidad, ...rest } = this.data;
                const payload = {
                    ...rest,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.update'), payload).then(res => {
                    this.errors = {};
                    this.originalData = { ...this.data };
                    this.$emit('updated')
                    this.$toast.success(this.$t('perfil_sga.perfil_actualizados_toast'));
                }).catch(error => {
                    this.errors = error.response.data.errors;
                    this.$toast.error(this.$t('perfil_sga.error_actualizar_perfil_toast'));
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        components: {
            Paises,
            Provincias,
            Locations,
            PhoneInput,
        },
    }
</script>